import React from 'react'
import { makeStyles } from '@material-ui/styles'
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Grid,
    Typography
} from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons'
import { useTranslation } from 'react-i18next'
import { LogoContainer } from '../Atoms'
import { MainPageContainer } from '../Organisms'

const useStyles = makeStyles(theme => ({
    title: {
        marginBottom: 25,
        width: "100%",
        textAlign: "center",
        fontFamily: "American Typewriter, serif",
        textDecoration: "underline #8FB4CA",
        textUnderlinePosition: "under"
    },
    body: {
        width: "50vw",
        marginBottom: 50,
    },
    accordionItem: {
        borderLeft: "5px solid #8FB4CA"
    }
}))


const FrequentlyAskedQuestions = () => {
    const { t } = useTranslation()
    const classes = useStyles()

    return (
        <LogoContainer>
            <MainPageContainer>
                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center">
                    <Typography variant="h2" className={classes.title}>Frequently Asked Questions</Typography>

                    <Grid className={classes.body}>
                        {t('faq', { returnObjects: true })
                            .map(({ question, answer }, index) => (
                                <Accordion key={index} className={classes.accordionItem}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography variant="h5">Q: {question}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>A: {answer}</Typography>
                                    </AccordionDetails>
                                </Accordion>
                            ))}
                    </Grid>
                </Grid>
            </MainPageContainer>
        </LogoContainer>
    )
}


export default FrequentlyAskedQuestions
